module.exports = __webpack_public_path__ + "img/interaction_right.01331b7f.png";